/**
 * Allowlist dos eventos que o microfrontend do Drive pode enviar ao Segment
 * via bridge postMessage (SEGMENT_TRACK). Nomes espelham o enum
 * DriveAnalyticsEvent do jusfy-drive-front. Eventos fora desta lista são
 * ignorados pelo host — o iframe não dita nomes arbitrários de evento.
 */
export const ALLOWED_DRIVE_IFRAME_SEGMENT_EVENTS = new Set<string>([
  'Drive Opened',
  'Drive Folder Created',
  'Drive File Uploaded',
  'Drive Searched',
  'Drive File Opened',
  'Drive Filtered',
  'Drive Item Moved',
  'Drive Item Deleted',
  'Drive Item Restored',
  'Drive Item Permanently Deleted',
  'Drive Folder Downloaded',
]);

/**
 * Subset dos eventos acima que alimenta o filtro do HubSpot — recebe a
 * property `filtro_hubspot: 1` no relay. Fora daqui, a property não existe
 * no payload.
 */
export const HUBSPOT_FILTER_DRIVE_IFRAME_EVENTS = new Set<string>([
  'Drive Folder Created',
  'Drive File Uploaded',
  'Drive Searched',
  'Drive File Opened',
  'Drive Filtered',
  'Drive Item Moved',
  'Drive Item Deleted',
  'Drive Item Permanently Deleted',
]);
